import { useState, useEffect } from "react";
import { clsx } from "clsx";
import ToggleSwitchSkeleton from "@/components/ui/ToggleSwitchSkeleton";
import { RadioGroupSkeleton } from "@/components/ui/radioGroupSkeleton";
import { useFormStateStore } from "@/components/context/useFormContext";

export default function FormSkeleton() {
	const { selectedIndex, formContainer } = useFormStateStore();
	const [isNavDivSmall, setIsNavDivSmall] = useState(false);

	// For form container
	useEffect(() => {
		const limiter = 520;

		setIsNavDivSmall(formContainer < limiter);
	}, [selectedIndex, formContainer]);

	return (
		<div className="jF-w-full jF-h-[857px] jF-block jF-pt-10 jF-px-4 jF-justify-center jF-items-center jF-bg-white jF-rounded-lg">
			<div className="jF-space-y-6">
				<div className="jF-flex jF-flex-col jF-items-center jF-justify-center jF-space-y-2">
					<div className="jF-h-10 jF-w-64 jF-rounded jF-bg-gray-200 jF-animate-pulse"></div>
					<div className="jF-h-8 jF-w-56 jF-rounded jF-bg-gray-200 jF-animate-pulse"></div>
				</div>
				<div className="jF-space-y-2">
					{/* Label */}
					<div className="jF-h-4 jF-w-24 jF-rounded jF-bg-gray-200 jF-animate-pulse"></div>

					{/* Input */}
					<div className="jF-h-10 jF-w-full jF-rounded-md jF-bg-gray-200 jF-animate-pulse"></div>
					{/* Input */}
					<div className="jF-h-10 jF-w-full jF-rounded-md jF-bg-gray-200 jF-animate-pulse"></div>
					{/* Input */}
					<div className="jF-h-10 jF-w-full jF-rounded-md jF-bg-gray-200 jF-animate-pulse"></div>
				</div>

				{/* Loan Types */}
				<RadioGroupSkeleton />

				<div
					className={clsx(
						isNavDivSmall
							? "jF-flex-col jF-gap-x-2  jF-space-y-2"
							: "jF-flex-row jF-gap-x-2",
						"jF-flex"
					)}
				>
					<div className="jF-flex-1">
						<div className="jF-space-y-2">
							{/* Label */}
							<div className="jF-h-4 jF-w-24 jF-rounded jF-bg-gray-200 jF-animate-pulse"></div>

							{/* Input */}
							<div className="jF-h-10 jF-w-full jF-rounded-md jF-bg-gray-200 jF-animate-pulse"></div>
						</div>
					</div>
				</div>
				<ToggleSwitchSkeleton />
			</div>
		</div>
	);
}
